import classnames from 'classnames';
import React, { ReactNode } from 'react';

const CSS = require('./Section.less');

export interface SectionProps {
  as?: 'section' | 'header' | 'footer' | 'aside' | 'main';
  variant?:
    | 'default'
    | 'sandstone'
    | 'purple'
    | 'dark-green'
    | 'misty-green'
    | 'sandstone-light';
  noSpace?: 'top' | 'bottom' | 'all';
  noPadding?: boolean;
  isNarrow?: boolean;
  className?: any;
  children: ReactNode | JSX.Element;
  [key: string]: any;
}

function Section({
  as: Component = 'section',
  variant = 'default',
  noSpace,
  noPadding,
  isNarrow,
  className,
  children,
  ...rest
}: SectionProps) {
  const classes = classnames(CSS.Section, className, {
    [CSS.VariantSandstone]: variant === 'sandstone',
    [CSS.VariantSandstoneLight]: variant === 'sandstone-light',
    [CSS.VariantPurple]: variant === 'purple',
    [CSS.VariantDarkGreen]: variant === 'dark-green',
    [CSS.VariantMistyGreen]: variant === 'misty-green',
    [CSS.NoTopSpace]: noSpace === 'top',
    [CSS.NoBottomSpace]: noSpace === 'bottom',
    [CSS.NoSpace]: noSpace === 'all',
    [CSS.NoPadding]: noPadding,
    [CSS.NarrowSection]: isNarrow,
  });
  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
}

export default Section;
